'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { fetchEscritoriosSituacao, fetchSituacoesArbitral, selectEscritoriosSituacaoOpcoes, selectSituacoesArbitral, selectSituacoesArbitralError, selectSituacoesArbitralLoading, selectSituacoesArbitralSaving } from '../store';
export function useSituacoesArbitral() {
  const $ = _c(12);
  const dispatch = useAppDispatch();
  const situacoes = useAppSelector(selectSituacoesArbitral);
  const escritorios = useAppSelector(selectEscritoriosSituacaoOpcoes);
  const loading = useAppSelector(selectSituacoesArbitralLoading);
  const saving = useAppSelector(selectSituacoesArbitralSaving);
  const error = useAppSelector(selectSituacoesArbitralError);
  let t0;
  if ($[0] !== dispatch) {
    t0 = () => {
      dispatch(fetchSituacoesArbitral());
    };
    $[0] = dispatch;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const recarregar = t0;
  let t1;
  let t2;
  if ($[2] !== dispatch) {
    t1 = () => {
      dispatch(fetchSituacoesArbitral());
      dispatch(fetchEscritoriosSituacao());
    };
    t2 = [dispatch];
    $[2] = dispatch;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  let t3;
  if ($[5] !== error || $[6] !== escritorios || $[7] !== loading || $[8] !== recarregar || $[9] !== saving || $[10] !== situacoes) {
    t3 = {
      situacoes,
      escritorios,
      loading,
      saving,
      error,
      recarregar
    };
    $[5] = error;
    $[6] = escritorios;
    $[7] = loading;
    $[8] = recarregar;
    $[9] = saving;
    $[10] = situacoes;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
}